// require('bootstrap-daterangepicker/daterangepicker.js')
require('perfect-scrollbar/dist/js/perfect-scrollbar.jquery.js')
require('bootstrap/js/dist/util.js')
require('bootstrap/js/dist/modal.js')
require('bootstrap/js/dist/tab.js')
require('bootstrap/js/dist/tooltip.js')
require('bootstrap/js/dist/popover.js')
require('./template')



// WEBPACK FOOTER //
// ./src/vendor/index.js